// extracted by mini-css-extract-plugin
export var cameraListingPager = "staticCameraList-module--cameraListingPager--05a2c";